import {OpenModalStates} from '../records/listingPageRecord';

const appendURLSearchParams = (baseUrl, searchParams) => {
    const searchParamsStr = searchParams.toString();
    return searchParamsStr ? `${baseUrl}?${searchParamsStr}` : baseUrl;
};

// Relative Universal Login localised url for brands support
const buildUniversalUrl = (queryParams, href, redirectToQueryParams) => {
    const url = new URL(href);
    const basePath = (url.pathname.match(/^\/[a-z]{2}-[a-z]{2}/) || [''])[0];

    let searchParams = new URLSearchParams(url.searchParams);
    Object.entries(redirectToQueryParams || {}).forEach(([key, value]) => {
        // Avoid duplicated entries
        if (!searchParams.has(key)) {
            searchParams.append(key, value);
        }
    });

    const searchParamsStr = searchParams.toString() ? `?${searchParams.toString()}` : '';
    const redirectTo = url.pathname + searchParamsStr;

    const newQueryParams = new URLSearchParams({
        enable_login: true,
        ...queryParams,
        redirectTo
    });

    return appendURLSearchParams(`${basePath}/login`, newQueryParams);
};

const inquiryMarketingPreferencePageType = 'inquiry';
const marketingPreferencePageName = 'node-traveler-property-ui';

const getLoginUrl = (href, rQueryParamValue) =>
    buildUniversalUrl({}, href, rQueryParamValue && {r: rQueryParamValue});

const getInquiryLoginUrl = (href) =>
    buildUniversalUrl(
        {
            referrer_page_location: inquiryMarketingPreferencePageType,
            referrer_page_name: marketingPreferencePageName
        },
        href,
        {r: OpenModalStates.INQUIRY}
    );

export {getInquiryLoginUrl, getLoginUrl, appendURLSearchParams};
